import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { SelectCustom } from '../../../../../../common/selectCustom'
import { valByKeyWithDot } from '../../../../../../helpers/value'

const ItemSelect = ({
  title,
  options,
  setting,
  keySetting,
  setValue,
  onChange,
  isI18n,
}) => {
  const activeValue = valByKeyWithDot(setting, keySetting, true)

  const handleChange = ({ value }) => {
    setValue(`setting.${keySetting}`, value)
    onChange && onChange(value, { setting, setValue })
  }

  return (
    <div className="dFlex alignItemsCenter gap1">
      <Element className="fw600" style={{ color: '#3A414B' }}>
        {isI18n ? <Translate value={title} /> : title}:
      </Element>
      <SelectCustom
        data={options}
        activeItem={{ value: activeValue }}
        chooseItem={handleChange}
        isI18n
        isBorderNone
        iconWhenShowDropList="icon-arrow-bottom"
        iconWhenHiddenDropList="icon-arrow-bottom"
        iconNoPosition
        style={{ padding: 0, alignItems: 'baseline' }}
        styleDropdown={{ whiteSpace: 'nowrap' }}
      />
    </div>
  )
}

ItemSelect.propTypes = {
  title: PropTypes.string.isRequired,
  isRequire: PropTypes.bool,
  keySetting: PropTypes.string.isRequired,
  setting: PropTypes.object,
  value: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  isI18n: PropTypes.bool,
}

ItemSelect.defaultProps = {
  isRequire: false,
}

export default ItemSelect
